import { useEffect, useState } from "react"
import { getCypher, getUserCypher } from "../../../api"
import { useAppState } from "../../../hooks"
import { ECathegory, ECypherType, TCypher, TUser } from "../../../types"
import { Helps } from "../../help"
import { Loading } from "../../loading"
import { Heading, Section } from "../../page"
import { PDFDownload } from "../pdfDownload"
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai';

import './cypher.scss'
import { GAMES, gameType, getCypherPointsText, getPointsText } from "../../../utils"
import { CypherRating } from "./CypherRating"

type CypherProps = {
    user: TUser,
    refreshUser: any
}

const startCypher = {
    Id: 0, name: 'Start', message: '', type: ECypherType.START }


export const Cypher = ({ user, refreshUser }: CypherProps) => {
    const { state } = useAppState()
    const [cypher, setCypher] = useState<TCypher>(startCypher)
    const [loading, setLoading] = useState(false)

    useEffect(() => {

        loadUserCypher()
    }, [user])


    const loadUserCypher = () => {
        if (user && state?.token) {
            setLoading(true)
            getUserCypher({ token: state.token }).then((res) => {
                if (res.cypher) {
                    setCypher(res.cypher)
                }
            }).finally(() => { setLoading(false) })
        }
    }

    const loadPreviousCypher = () => {
        if (cypher && state?.token) {
            setLoading(true)
            getCypher({ id: cypher.Id - 1, token: state.token }).then((res) => {
                console.log(res.cypher)
                if (res.cypher) {
                    setCypher(res.cypher)
                }
            }).finally(() => { setLoading(false) })
        }
    }

    const loadNextCypher = () => {
        if (cypher && state?.token) {
            setLoading(true)
            getCypher({ id: cypher.Id + 1, token: state.token }).then((res) => {
                if (res.cypher) {
                    setCypher(res.cypher)
                }
            }).finally(() => { setLoading(false) })
        }
    }

    if (loading) {
        return <Loading />
    }

    if (user.GameInfo?.cypher == undefined) {
        return <></>
    }

    return (
        <>
            <Heading headline={`Stanoviště ${cypher.name}`} weight={2} centered={true} />
            {
                gameType() === GAMES.ZKRATKA && cypher.points!! > 0
                    ? <div className='cypher__points'> <div className='cypher__points__label'>Max {getCypherPointsText(cypher.points!)}</div></div>
                : <></>
            }            
            <Section>
                {
                    cypher.message ? <div dangerouslySetInnerHTML={{ __html: cypher.message }}/> : ''
                }

                {
                    gameType() === GAMES.ZKRATKA ? (
                        cypher.Id === 0
                            ? <p>Pokud potřebujete Průvodce Zkratkou v PDF, můžete si jej stáhnout <a href='https://www.sifrovacihra.cz/zkratka/2024/Pruvodce.pdf' target='_blank'>zde</a>.</p>
                            : ''
                    ) : ''
                }
                {
                    gameType() === GAMES.ZKRATKA ? (
                        user?.GameInfo?.cypher === 0 && cypher.Id === 0
                            ? <p>Pdf zadání startovních šifer naleznete zde po zadání kódu 1. šifry, který naleznete ve startovní obálce. (Je potřeba se potom vrátit na tuto stránku tlačítkem "předchozí" pod nápovědami).</p>
                            : ''
                    ) : ''
                }
                {

                    user?.GameInfo?.cypher === 1 && cypher.Id === 1
                        ? (
                            {
                                0: <></>,
                                1:
                                    <>
                                        <p>Na tuto šifru nejsou nápovědy přes websystém, získáte je následovně:</p>
                                        <ul>
                                            <li>V 9:30 si můžete přijít pro jednotlivé indicie, které jste ještě nezískali (k organizátorům, kteří je mezi 9:00 a 9:30 vydávají za řešení šifřiček),</li>

                                            {user?.Cathegory === ECathegory.P ? <li>V 9:30 si také můžete přijít pro nápovědu k hlavní startovní šifře do klubovky,</li> : ''}

                                            <li>V 10:00 si můžete do klubovky přijít pro řešení startovní šifry.</li>
                                        </ul>

                                    </>,
                                2: <p>Zadání této šifry v PDF budete mít k dispozici až zpětně po příchodu na 2. šifru. Teď už si můžete stáhnout zadání startovních šifřiček, když se přepnete na předchozí stanoviště pomocí šipky úplně dole na stránce.</p>
                            }[gameType()]
                        ) : ''
                }
                {
                    gameType() === GAMES.ZKRATKA ? (
                        <PDFDownload cypher={cypher} />
                    ) : ''
                }
            </Section>
            
            {
                user?.GameInfo?.cypher > cypher.Id
                    ? <Section>
                        {(cypher.type === ECypherType.CYPHER || cypher.type === ECypherType.START)
                            ? <CypherRating cypherId={cypher.Id} user={user } />
                            : <></>
                        }
                    </Section>
                    : <></>
            }
            <Section>
                {cypher.helps ? <Helps helps={cypher.helps} refreshUser={refreshUser} userCypher={user?.GameInfo?.cypher} userCathegory={user.Cathegory} /> : ''}
            </Section>
            {
                (user?.GameInfo?.cypher === cypher.Id && cypher.Id > 0)
                    ? <Section>
                        {(cypher.type === ECypherType.CYPHER || cypher.type === ECypherType.START)
                            ? <CypherRating cypherId={cypher.Id} user={user }/>
                            : <></>
                        }
                    </Section>
                    : <></>
            }
            {
                gameType() === GAMES.ZKRATKA ? (
                    <Section>
                        <div className='cypher__select-cypher'>
                            {cypher.Id > 0 ? <div className='cypher__select-previous' onClick={loadPreviousCypher}><AiOutlineLeft /> Předchozí</div> : ''}
                            {cypher.Id < user.GameInfo?.cypher ? <div className='cypher__select-next' onClick={loadNextCypher}> Další <AiOutlineRight /></div> : ''}
                        </div>
                    </Section>
                ) : ''
            }
        </>
    )
}